import "./main.js"
import "./piechartNew.js"
import "./chart_base.js"
import "./lang/jp"
import "./conf.js"
import "./svgCharts/svgChartDrawUtil.js"
import "./svgCharts/svgChartUtil.js"
import "./svgCharts/svgChartCache.js"
import "./svgCharts/svgChartMapping.js"
import "./svgCharts/svgChartProjector.js"
import "./svgCharts/svgChartTechnical.js"
import "./svgCharts/svgChartConfig.js"
import "./svgCharts/svgChartView.js"
import "./svgCharts/svgChartActionView.js"
import "./svgCharts/svgChartScrollView.js"
import "./svgCharts/svgChart.js"
import "./sw_i18n_en.js"
